const title = "_arat1huekqn";
const heading = "_arah1pejabf";
const headingDescription = "_arah1x3iqyv";
const collapseChevron = "_aracua6v09";

export { collapseChevron, heading, headingDescription, title };
import "./atom.title.style.linaria.module.css";
//# sourceMappingURL=atom.title.style.js.map
